import BatteryTechReview from './BatteryTechReview';

export default BatteryTechReview;
